import React, { Component } from 'react';
import './_styles.scss';

class LayoutThreeAddOn extends Component {
	constructor(props) {
	    super(props);
	}

	render() {
		const { groups: imagesAddOn = [] } = this.props || {};

		return (
			<div className="landing-comercial-3-addon landing-comercial-3-addon--flex">
				<div className="landing-comercial-3-addon__top">
					<div className="landing-comercial-3-addon__tile">
						<img className="landing-comercial-3-addon__img" src={imagesAddOn[0].images.large} alt="AddOn-1" />
                        <div className="landing-comercial-3-addon__overlay">
						    <span className="landing-comercial-3-addon__title">{imagesAddOn[0].title}</span>
                        </div>
					</div>
					<div className="landing-comercial-3-addon__tile">
						<img className="landing-comercial-3-addon__img" src={imagesAddOn[1].images.large} alt="AddOn-2" />
                        <div className="landing-comercial-3-addon__overlay">
						    <span className="landing-comercial-3-addon__title">{imagesAddOn[1].title}</span>
                        </div>
					</div>
				</div>
				<div className="landing-comercial-3-addon__bottom">
					<img className="landing-comercial-3-addon__img" src={imagesAddOn[2].images.large} alt="AddOn-3" />
                    <div className="landing-comercial-3-addon__overlay">
					    <span className="landing-comercial-3-addon__title">{imagesAddOn[2].title}</span>
                    </div>
				</div>
			</div>
		);
	}
}
export default LayoutThreeAddOn;



// WEBPACK FOOTER //
// ./src/payments/DetailSelector/LandingComercialAddOn/Components/LayoutThreeAddOn/index.jsx